import { CHANGE_DISTANCE_DETAILS_ERROR_KEYS, CHANGE_DISTANCE_DETAILS_UNKNOWN } from 'src/modules/changeDistance/constants';

import { snackStore } from 'stores';

import { SNACK_SCOPES } from '../../../constants';

let snackId: string;

function show(errorCode: string) {
  const snackParams = {
    i18key: CHANGE_DISTANCE_DETAILS_ERROR_KEYS[errorCode] || CHANGE_DISTANCE_DETAILS_ERROR_KEYS[CHANGE_DISTANCE_DETAILS_UNKNOWN],
  };

  clean();
  snackId = snackStore.error(snackParams, { scope: SNACK_SCOPES.changeDistance });
}

function clean() {
  snackId && snackStore.removeValue(snackId);
}

const changeDistanceUnusableTokenSnack = {
  show,
  clean,
};

export { changeDistanceUnusableTokenSnack };
